import { PageIDModel } from '../vo/page-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 注文コードSEQ№一括設定コマンド
 *
 * @export
 * @class SetOrderNumSeqNoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class SetOrderNumSeqNoService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private vo: PageIDModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SetOrderNumSeqNoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PageID: this.vo.pageID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {PageIDModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof SetOrderNumSeqNoService
   */
  execute(vo: PageIDModel, successFunction: Function) {
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14setOrderNumSeqNo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof SetOrderNumSeqNoService
   */
  success(_: any) {
    this.successFunction();
  }
}
